// extracted by mini-css-extract-plugin
export default {"loader":"ProgressLoader_loader__B57Eo","loader__box":"ProgressLoader_loader__box__MaUnw","jump_4123":"ProgressLoader_jump_4123__d5jkg"};